// tuning/title.ts (title screen, 2026-10-05) — the showcase town behind the title, its camera, and the title music's timings.
import type { TuningBank } from '../schema/tuning';

export default {
  seed: 7,                    // the showcase town every launch builds locally (generateTown), the same island for everyone
  // Houses on the plots nearest the plaza: friends first (a kit roof colour and the friend colour of their fence and flower bed), then
  // villagers in their own house themes. The rest of the plots stay empty, as in a town that still has room.
  friendHouses: [
    { roof: 'red', color: 'coral', level: 2 },
    { roof: 'blue', color: 'sky', level: 3 },
    { roof: 'yellow', color: 'lilac', level: 1 },
    { roof: 'green', color: 'marigold', level: 2 },
  ],
  villagerHouses: 4,
  wanderers: 3,               // villagers strolling near the plaza
  wanderRadius: 9,            // tiles from the plaza centre a stroll may end at
  wanderIdleSeconds: [2, 6],  // a pause between strolls
  // The slow turn high above the town: camera distance and pitch around the plaza centre, one turn per periodSeconds.
  // screenShift: how far right of centre (a share of the screen width) the town turns, clear of the title's words on the left; the
  // swoop brings it back to the middle.
  // portrait (2026-10-18), a phone held upright: the words sit at the top and Play now at the foot, so the town turns shiftY of the
  // screen's height below the middle; the view widens to show about as much of the town across as a screen fitAspect wide (width over
  // height) would, held to maxFovDeg (vertical). Both ease back to the town camera's view on the way down.
  orbit: { distance: 46, pitchDeg: 36, periodSeconds: 160, startYawDeg: -30, screenShift: 0.2,
    portrait: { fitAspect: 0.8, maxFovDeg: 62, shiftY: 0.04 } },
  orbitFog: [70, 210],        // fog near/far while high up (the town camera's own fog takes over by the end of the swoop)
  // The title's own grade over the clock's lighting (title polish, 2026-10-06): the town behind the title and the pre-town panels is lit
  // for the player's local time, but never darker than a cosy evening. The sky, the lit windows and the lamps keep the clock's values;
  // only the lights on the town are lifted. In-town lighting is untouched (engine/lighting.ts).
  //   hemiFloor / sunFloor: the least hemisphere and sun intensity (tuning.light: midday 1.5 / 3.0; dusk 1.45 / 0.8; night 1.3 / 0.7).
  //   sunMinY: the least height of the sun's direction (normalised), so a low evening sun doesn't throw the plaza into long shade.
  //   warmth: how far, at the darkest, the light colours lean to the warm fill below (scaled by how much the floor had to lift).
  grade: { hemiFloor: 1.5, sunFloor: 1.4, sunMinY: 0.45, warmth: 0.45,
    fillSky: '#FFE3C4', fillGround: '#7DAA6A', fillSun: '#FFCB98' },
  swoopMs: 2200,              // Play now: from the turn down to the town camera
  fadeMs: 700,                // …or, with reduced motion, a fade through the sky instead
  crossfadeMs: 2500,          // title music into the town music (and back on the towns list)
} as const satisfies TuningBank;
